import { config } from '@amplement/backend-connector';

export const isLiveDebug = () => window.location.href.indexOf('trace=1') !== -1 || config.debug;
